import { createAction, props } from '@ngrx/store';

import { T2Code } from '@lockton-apps/shared/interfaces';

export enum T2CodeApiActionTypes {
  LoadAllSuccess = '[T2Codes API] Load All Success',
  LoadAllFailure = '[T2Codes API] Load All Failure',
}

export const T2CodeApiActions = {
  loadAllSuccess: createAction(
    T2CodeApiActionTypes.LoadAllSuccess,
    props<{ t2Codes: T2Code[] }>()
  ),
  loadAllFailure: createAction(
    T2CodeApiActionTypes.LoadAllFailure,
    props<{ error: any }>()
  ),
};
